exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html {\n  position: relative;\n  min-height: 100%;\n}\n\nbody { padding-top: 70px; }\n\nfooter {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 20px;\n  color: #fff;\n  text-align: center;\n  background-color: #e95420;\n}\n\n.glyphicon.spinning {\n    animation: spin 1s infinite linear;\n    -webkit-animation: spin2 1s infinite linear;\n}\n\n@-webkit-keyframes spin {\n    from { -webkit-transform: scale(1) rotate(0deg); transform: scale(1) rotate(0deg); }\n    to { -webkit-transform: scale(1) rotate(360deg); transform: scale(1) rotate(360deg); }\n}\n\n@keyframes spin {\n    from { -webkit-transform: scale(1) rotate(0deg); transform: scale(1) rotate(0deg); }\n    to { -webkit-transform: scale(1) rotate(360deg); transform: scale(1) rotate(360deg); }\n}\n\n@-webkit-keyframes spin2 {\n    from { -webkit-transform: rotate(0deg); }\n    to { -webkit-transform: rotate(360deg); }\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./src/styles.css
// module id = 229
// module chunks = 2